import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const ANALYTICS_EVENT_SOURCE = new InjectionToken<BehaviorSubject<string>>('ANALYTICS_EVENT_SOURCE');
